import { render, staticRenderFns } from "./WorkflowMenu.vue?vue&type=template&id=07baf05f&scoped=true"
import script from "./WorkflowMenu.vue?vue&type=script&lang=js"
export * from "./WorkflowMenu.vue?vue&type=script&lang=js"
import style0 from "./WorkflowMenu.vue?vue&type=style&index=0&id=07baf05f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07baf05f",
  null
  
)

export default component.exports